import { IPart } from "../../models/Part";
import usePartDetails from "../../data/usePartDetails";
import LoadingWheel from "../shared/LoadingWheel";
import EditListingImages from "../ebayListings/EditListingImages";

// The optimisation expanded row is images only. Unlike the staged column edits, the photo
// manager writes to the part immediately - uploads, reorders and deletes are live.
export default function OptimisationImagesRow({ part }: { part: IPart }) {
  // Paged `/part/listings` rows carry a trimmed image array, so pull the full part in.
  const { partDetails, isLoading, isError } = usePartDetails(part.id, true);
  const fullPart = partDetails || part;

  if (isLoading && !partDetails) {
    return (
      <div className="flex items-center justify-center p-8">
        <LoadingWheel />
        <span className="ml-4 text-gray-600">Loading images...</span>
      </div>
    );
  }

  if (isError && !partDetails) {
    return (
      <div className="m-2 rounded-md border border-yellow-200 bg-yellow-50 p-4">
        <p className="text-yellow-800">Unable to load images for this part.</p>
      </div>
    );
  }

  return (
    <div className="w-full p-2">
      <EditListingImages part={fullPart} />
    </div>
  );
}
